export default {"src":"/pro/_next/static/media/ldo.aab45223.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};